import { FileUpload } from 'primereact/fileupload'
import { Panel } from 'primereact/panel'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { PageHeader, TextBtn } from '../../../../components'
import * as ImportacaoHttp from '../../../../services/api/https/deliveries/importation.http'
import { urlPostImportacaoInfoEdi } from '../../../../services/api/routes/deliveries.routes'
import { errorHandler } from '../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import CardsResultadoImportacao from '../ImportacaoCicloEntrega/CardsResultadoImportacao'
import TabsClientesEhProdutosNaoCadastrados from '../ImportacaoCicloEntrega/TabsClientesEhProdutosNaoCadastrados'

const mapStateToProps = ({ ciclo_entrega: { selectedCiclo } }) => ({ selectedCiclo })
export default connect(mapStateToProps)(withRouter(ImportacaoCicloEntregaEdi))

const ShowMode = {
  MESSAGE: 'MESSAGE',
  CARDS: 'CARDS',
  TABS: 'TABS',
}

function ImportacaoCicloEntregaEdi({ history, dispatch, selectedCiclo }) {
  const { cicloId, file_type_id } = selectedCiclo

  // Hooks
  const [showMode, setShowMode] = useState(ShowMode.MESSAGE)
  const [result, setResult] = useState({
    qteDeliveries: '',
    qteIdentifiers: '',
    qteSkus: '',
    weight: '',
  })
  const [produtosSemCadastros, setProdutosSemCadastros] = useState([])
  const [produtosComInconsistencia, setProdutosComInconsistencia] = useState([])
  const [clientesSemCadastros, setClientesSemCadastros] = useState([])

  useEffect(() => {
    async function fetchCicloInfo() {
      try {
        const { qteDeliveries, qteIdentifiers, qteSkus, weight } =
          await ImportacaoHttp.getCicloInfo(cicloId)
        if (qteDeliveries) {
          setShowMode(ShowMode.CARDS)
          setResult({ qteDeliveries, qteIdentifiers, qteSkus, weight })
        } else {
          setShowMode(ShowMode.MESSAGE)
        }
      } catch (error) {
        dispatch(showMessageBox(null, error))
        setShowMode(ShowMode.MESSAGE)
      }
    }
    cicloId && !Number.isNaN(cicloId) && fetchCicloInfo()
  }, [cicloId])

  // Events
  const onError = error => {
    dispatch(hideLoadingBox())
    const {
      xhr: { response },
    } = error

    const {
      message,
      clientsNotSaved = [],
      productsNotSaved = [],
      productsWithInconsistency = [],
    } = JSON.parse(response)
    if (message) {
      dispatch(showMessageBox(null, message))
      if (
        clientsNotSaved.length > 0 ||
        productsNotSaved.length > 0 ||
        productsWithInconsistency.length > 0
      ) {
        setProdutosSemCadastros(productsNotSaved)
        setProdutosComInconsistencia(productsWithInconsistency)
        setClientesSemCadastros(clientsNotSaved)
        setShowMode(ShowMode.TABS)
      }
    } else {
      setShowMode(ShowMode.MESSAGE)
      dispatch(showMessageBox(null, errorHandler(JSON.parse(response))))
    }
  }

  const onEdiImportationSuccess = async data => {
    dispatch(hideLoadingBox())
    const {
      xhr: { response },
    } = data
    const { qteDeliveries, qteIdentifiers, qteSkus, weight } = JSON.parse(response)
    dispatch(showMessageBox('Importação realizada com sucesso', null))
    setShowMode(ShowMode.CARDS)
    setResult({ qteDeliveries, qteIdentifiers, qteSkus, weight })
  }

  // Render
  return (
    <>
      <PageHeader>
        Importação&nbsp;<strong>EDI - NOTIFIS</strong>&nbsp;-&nbsp;Ciclos de Entrega&nbsp;-&nbsp;
        <strong>{selectedCiclo.cicloName}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel
          header={
            <ImportacaoPanelHeader
              onError={onError}
              onSuccess={onEdiImportationSuccess}
              onVoltar={history.goBack}
              onBeforeSend={() => dispatch(showLoadingBox('Importando o arquivo . . ', 'Aguarde'))}
              cicloId={cicloId}
              fileTypeId={file_type_id}
            />
          }
        >
          {showMode === ShowMode.MESSAGE ? (
            <div style={{ textAlign: 'center', color: '#c4c4c4' }}>
              Para realizar a importação, clique no botão Importar e selecione o arquivo EDI (.txt)
            </div>
          ) : null}
          {showMode === ShowMode.CARDS ? (
            <CardsResultadoImportacao
              weight={result.weight}
              qteSkus={result.qteSkus}
              qteIdentifiers={result.qteIdentifiers}
              qteDeliveries={result.qteDeliveries}
            />
          ) : null}
          {showMode === ShowMode.TABS ? (
            <TabsClientesEhProdutosNaoCadastrados
              produtosSemCadastros={produtosSemCadastros}
              clientesSemCadastros={clientesSemCadastros}
              produtosComInconsistencia={produtosComInconsistencia}
            />
          ) : null}
        </Panel>
      </div>
    </>
  )
}

function ImportacaoPanelHeader({
  onError,
  onSuccess,
  onVoltar,
  onBeforeSend,
  cicloId,
  fileTypeId,
}) {
  // Render
  return (
    <div className="p-grid">
      <div className="p-col-2">
        <div style={{ display: 'flex' }}>
          <div className="text-center">
            <FileUpload
              disabled={false}
              name={'importacao-edi'}
              url={urlPostImportacaoInfoEdi(cicloId, fileTypeId)}
              mode="basic"
              chooseLabel={'Importar'}
              onUpload={onSuccess}
              onBeforeSend={onBeforeSend}
              onError={onError}
              accept={'.txt'}
            ></FileUpload>
          </div>
          <TextBtn onClick={onVoltar}>Voltar</TextBtn>
        </div>
      </div>
    </div>
  )
}
